import { render, staticRenderFns } from "./basket-order.vue?vue&type=template&id=7ddb654f"
import script from "./basket-order.vue?vue&type=script&lang=js"
export * from "./basket-order.vue?vue&type=script&lang=js"
import style0 from "./basket-order.vue?vue&type=style&index=0&id=7ddb654f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports